/* eslint-disable max-len */
export default {
  Title: 'Voice Interview',
  Subtitle: 'Complete your caregiver application with a brief interview with our AI assistant',
  Status: {
    Connecting: 'Connecting...',
    AISpeaking: 'AI is Speaking...',
    AIListening: 'AI is Listening...',
    Completed: 'Interview Completed',
    ReadyToStart: 'Ready to Start',
  },
  Duration: 'Duration: #{duration}',
  ReadyToStart: {
    Title: 'Ready to start your interview?',
    Instructions: 'This interview will take about 5-10 minutes. Make sure you\'re in a quiet environment and have a stable internet connection.',
    StartButton: 'Start Interview',
  },
  Connecting: {
    Title: 'Connecting to interview agent...',
    Message: 'Please wait while we establish the connection',
  },
  InProgress: {
    Title: 'Interview in progress',
    Instructions: 'The AI assistant is asking you questions about your caregiving experience. Speak clearly and take your time to answer.',
    EndButton: 'End Interview',
  },
  Completed: {
    Title: 'Interview Completed Successfully!',
    Message: `We appreciate you taking the time to share your responses. Your interview has been successfully recorded and will be reviewed shortly by one of our Care Managers.
<br/>
There is no further action needed on your part at this time. Please be patient as we carefully review your application. Once a decision has been made or if we need additional information, we will reach out to you directly.
<br/>
Thank you for your time and interest - we’re looking forward to connecting with you soon.`,
  },
  Guidelines: {
    Title: 'Interview Guidelines',
    QuietEnvironment: '• Ensure you\'re in a quiet environment',
    SpeakClearly: '• Speak clearly and at a normal pace',
    BeHonest: '• Be honest and provide specific examples when possible',
    CoverTopics: '• The interview will cover your experience, availability, and motivations',
  },
};
